export { default } from './FFHomeHeroBanner'
